/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  UpdateTraceabilitySourceContextIdentityMutationRequest,
  UpdateTraceabilitySourceContextIdentityMutationResponse,
  UpdateTraceabilitySourceContextIdentityPathParams,
} from "../types/UpdateTraceabilitySourceContextIdentity.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const updateTraceabilitySourceContextIdentityMutationKey = () =>
  [{ url: "/v1/traceability-source-contexts/:id" }] as const

export type UpdateTraceabilitySourceContextIdentityMutationKey = ReturnType<
  typeof updateTraceabilitySourceContextIdentityMutationKey
>

/**
 * @description Edits supplier contact, optional facility, and optional sourceReference on a DRAFT context.
 * @summary Update DRAFT source context identity
 * {@link /v1/traceability-source-contexts/:id}
 */
export async function updateTraceabilitySourceContextIdentity(
  id: UpdateTraceabilitySourceContextIdentityPathParams["id"],
  data: UpdateTraceabilitySourceContextIdentityMutationRequest,
  config: Partial<
    RequestConfig<UpdateTraceabilitySourceContextIdentityMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateTraceabilitySourceContextIdentityMutationResponse,
    ResponseErrorConfig<Error>,
    UpdateTraceabilitySourceContextIdentityMutationRequest
  >({
    method: "PATCH",
    url: `/v1/traceability-source-contexts/${id}`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function updateTraceabilitySourceContextIdentityMutationOptions<
  TContext = unknown,
>(
  config: Partial<
    RequestConfig<UpdateTraceabilitySourceContextIdentityMutationRequest>
  > & { client?: Client } = {}
) {
  const mutationKey = updateTraceabilitySourceContextIdentityMutationKey()
  return mutationOptions<
    ResponseConfig<UpdateTraceabilitySourceContextIdentityMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateTraceabilitySourceContextIdentityPathParams["id"]
      data: UpdateTraceabilitySourceContextIdentityMutationRequest
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, data }) => {
      return updateTraceabilitySourceContextIdentity(id, data, config)
    },
  })
}

/**
 * @description Edits supplier contact, optional facility, and optional sourceReference on a DRAFT context.
 * @summary Update DRAFT source context identity
 * {@link /v1/traceability-source-contexts/:id}
 */
export function useUpdateTraceabilitySourceContextIdentity<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<UpdateTraceabilitySourceContextIdentityMutationResponse>,
      ResponseErrorConfig<Error>,
      {
        id: UpdateTraceabilitySourceContextIdentityPathParams["id"]
        data: UpdateTraceabilitySourceContextIdentityMutationRequest
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<
      RequestConfig<UpdateTraceabilitySourceContextIdentityMutationRequest>
    > & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ??
    updateTraceabilitySourceContextIdentityMutationKey()

  const baseOptions = updateTraceabilitySourceContextIdentityMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<UpdateTraceabilitySourceContextIdentityMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateTraceabilitySourceContextIdentityPathParams["id"]
      data: UpdateTraceabilitySourceContextIdentityMutationRequest
    },
    TContext
  >

  return useMutation<
    ResponseConfig<UpdateTraceabilitySourceContextIdentityMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateTraceabilitySourceContextIdentityPathParams["id"]
      data: UpdateTraceabilitySourceContextIdentityMutationRequest
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<UpdateTraceabilitySourceContextIdentityMutationResponse>,
    ResponseErrorConfig<Error>,
    {
      id: UpdateTraceabilitySourceContextIdentityPathParams["id"]
      data: UpdateTraceabilitySourceContextIdentityMutationRequest
    },
    TContext
  >
}
